import { getStore } from "@/store";
import { openLogin } from "@/utils/login";
import { getAppInstance, Toast, checkLogin, isApp } from "@/utils/app";
import { set } from "lodash-es";
import { PageJumpType } from "@/enum/PageJumpType";

const homePath = "/";

const whiteList = [homePath, "/share"]; // no redirect whitelist

const tyApp = getAppInstance();

export function initPermission(router) {
  router.beforeEach(async (to, from, next) => {
    const store = getStore();
    const { name, fullPath } = to;
    const hasRecord = store.getters.cacheViewArr.some(
      (item) => item.fullPath === fullPath
    );
    set(
      to,
      "params['stack-key-dir']",
      hasRecord ? PageJumpType.back.value : PageJumpType.forward.value
    );
    await store.dispatch("cacheView/addCacheView", { name, fullPath });
    const callback = () => {
      if (tyApp) {
        if (to.path === homePath) {
          tyApp.nsCall({
            method: "showTabs",
          });
        } else {
          tyApp.nsCall({
            method: "hideTabs",
          });
        }
      }
      next();
    };

    if (whiteList.includes(to.path)) {
      return callback();
    }

    if (isApp()) {
      // app端路线
      if (await checkLogin()) {
        callback();
      }
    } else {
      // pc端路线
      let userInfo = store?.getters?.userInfo;
      // 如果vuex中没有用户信息，先调用接口获取，并缓存到vuex中
      if (!userInfo) userInfo = await store.dispatch("user/getUserInfo");
      if (!userInfo) {
        Toast.fail("请先登录");
        openLogin();
      } else {
        callback();
      }
    }
  });
}
